import React, { useEffect, useState } from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import { ArrowLeft, Loader2 } from 'lucide-react';
import { Layout } from './Home';
import PageHero from '../components/PageHero';
import RichContent from '../components/RichContent';
import { getVertical, resolveFileUrl } from '../services/api';

const VerticalDetail = () => {
  const { slug } = useParams();
  const [item, setItem] = useState(null);
  const [notFound, setNotFound] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    setNotFound(false);
    getVertical(slug)
      .then((v) => setItem(v))
      .catch((err) => {
        if (err?.response?.status === 404) setNotFound(true);
      })
      .finally(() => setLoading(false));
  }, [slug]);

  if (notFound) return <Navigate to="/verticals" replace />;

  return (
    <Layout>
      {loading || !item ? (
        <div className="bg-[#e2ede6] py-32 text-center text-[#0b1a2e]/60">
          <Loader2 className="w-6 h-6 animate-spin inline mr-2" /> Loading…
        </div>
      ) : (
        <>
          <PageHero
            eyebrow={item.eyebrow || 'Vertical'}
            title={item.title}
            description={item.brief}
            image={resolveFileUrl(item.image_url) || 'https://images.unsplash.com/photo-1604352704611-cce8fe2a4e0d?w=1600&q=80'}
          />
          <section className="bg-[#e2ede6] py-16 lg:py-24">
            <div className="max-w-4xl mx-auto px-6 lg:px-8">
              <div className="bg-white rounded-2xl border border-black/5 p-6 lg:p-10 shadow-sm">
                <RichContent text={item.details} />
              </div>
              <div className="mt-8 text-center">
                <Link
                  to="/verticals"
                  className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-[#0f5c3d]/25 text-[#0b1a2e] text-sm hover:bg-white transition"
                >
                  <ArrowLeft className="w-4 h-4" /> All verticals
                </Link>
              </div>
            </div>
          </section>
        </>
      )}
    </Layout>
  );
};

export default VerticalDetail;
